import { render } from "./MapDetails.vue?vue&type=template&id=35d3ce21"
import script from "./MapDetails.vue?vue&type=script&lang=js"
export * from "./MapDetails.vue?vue&type=script&lang=js"

import "./MapDetails.vue?vue&type=style&index=0&id=35d3ce21&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__